import type { FC, ButtonHTMLAttributes } from 'react'

import styled from 'styled-components'

import { space } from 'theme/utils'

import { Button as StyledButton } from './styles'

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'secondary' | 'tertiary'
  size?: 'small' | 'medium' | 'large'
  noPadding?: boolean
}

const Content = styled.div`
  align-items: center;
  display: flex;
  gap: ${space(2)};
  justify-content: center;

  svg {
    &:first-child {
      margin-right: ${space(2)};
    }
    &:last-child {
      margin-left: ${space(2)};
    }
    &:first-child:last-child {
      margin-left: 0;
      margin-right: 0;
    }
  }
`

export const Button: FC<ButtonProps> = ({
  children,
  variant,
  onClick,
  disabled,
  size,
  noPadding = false,
  ...rest
}) => (
  <StyledButton
    onClick={onClick}
    disabled={disabled}
    $variant={variant}
    size={size}
    $noPadding={noPadding}
    {...rest}
  >
    <Content>{children}</Content>
  </StyledButton>
)
